import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import * as moment from 'moment-timezone';

import dictionary from "dict/static.json";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HelperService } from "../../../lib/helper.service";

@Component({
	templateUrl: './details.component.html'
})
export class PaymentStructureDetailComponent extends InfoModalComponent {
	public moment = moment;

	statsLoader: boolean = false;
	stats;

	get currencyList() { return dictionary.currencyList }

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
	) {
		super(activeModal);
	}


	ok() {
		this.close();
	}
}
